import React, { useState, useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import { formatMoneda } from "../util/varios";
import moment from "moment";
import axios from "axios";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";

function Inicio() {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const txtMesPetro = useRef();
  const txtMesUTE = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [valor, setValor] = useState([]);
  const [valoru, setValoru] = useState([]);
  const [metv, setMetv] = useState([
    {
      muno: "174001.22",
      mdos: "174001.22",
      mtres: "174001.22",
      mcuatro: "174001.22",
      mcinco: "174001.22",
    },
  ]);
  const [total, setTotal] = useState(0.0);
  const [totalu, setTotalu] = useState(0.0);
  const [menor, setMenor] = useState(0);
  const [menorp, setMenorp] = useState(0);
  const [menorpi, setMenorpi] = useState("");
  const [icn, setIcn] = useState("");
  const [colorss, setColorss] = useState("");
  const [menorpii, setMenorpii] = useState("");
  const [icnd, setIcnd] = useState("");
  const [colorssd, setColorssd] = useState("");
  const [colorG, setColorG] = useState(["#0d6efd", "#dc3545"]);
  const [nomimp, setNomimp] = useState([]);
  const [valorimp, setValorimp] = useState([]);
  const [activate, setActivate] = useState(false);
  const [label, setLabel] = useState([]);
  const [labelu, setLabelu] = useState([]);
  const [mesesIngresoGeneral, setMesesIngresoGeneral] = useState([]);
  const [ingresos, setIngresos] = useState([]);
  const [metaIngreGeneral, setMetaIngreGeneral] = useState([]);

  const seleccionarValorPetro = (m) => {
    let endpoint = `${op.conexion}/api/valorpetro/valorpetrofecha?mes=${m}&anio=${anioActu}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            let to = 0;
            let te = 0;
            let contar = 0;
            var label = [];
            var datos = [];

            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].anio === anioActu.toString()) {
                contar = contar + 1;
                label.push(moment(response.data[i].fechaaplic).format("DD-MM"));
                datos.push(response.data[i].valor);
              }
            }

            if (contar > 1) {
              to = contar - 2;
              te = contar - 1;
            }

            setValor(datos);
            setLabel(label);

            let porcp = 0.0;
            let totalpcp = 0.0;
            let totalreal = 0.0;

            if (datos[to] > datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setMenorp(7);
              setMenorpi(
                <i
                  className="fas fa-arrow-down me-2"
                  style={{ color: "#F93154" }}
                />
              );
              setColorss("#F93154");
              setIcn(
                <i className="fas fa-percent" style={{ color: "#F93154" }} />
              );
            } else if (datos[to] < datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setMenorp(1);
              setMenorpi(
                <i
                  className="fas fa-arrow-up me-2"
                  style={{ color: "#00B74A" }}
                />
              );
              setColorss("#00B74A");
              setIcn(
                <i className="fas fa-percent" style={{ color: "#00B74A" }} />
              );
            } else if ((datos[to] = datos[te])) {
              setMenorp(5);
              setMenorpi(
                <i
                  className="fas fa-equals me-2"
                  style={{ color: "#025558" }}
                />
              );
              setColorss("#025558");
              setIcn(
                <i className="fas fa-percent" style={{ color: "#025558" }} />
              );
            }
            setTotal(totalpcp);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => setActivate(false));
  };

  const seleccionarValorUT = (m) => {
    let endpoint = `${op.conexion}/api/valorute/seleccionaelporcentaje?anio=${anioActu}&mes=${m}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            let contar = 0;
            let to = 0;
            let te = 0;
            var label = [];
            var datos = [];
            let valor = 0.0;

            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].anio === anioActu.toString()) {
                contar = contar + 1;
                let val = response.data[i].valor;
                let porctj = response.data[i].porct;

                label.push(moment(response.data[i].fechaaplic).format("DD-MM"));
                datos.push((valor = val * porctj));
              }
            }

            if (contar > 1) {
              to = contar - 2;
              te = contar - 1;
            }

            setValoru(datos);
            setLabelu(label);

            let porcp = 0.0;
            let totalpcp = 0.0;
            let totalreal = 0.0;
            if (datos[to] > datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setMenor(6);
              setMenorpii(
                <i
                  className="fas fa-arrow-down me-2"
                  style={{ color: "#F93154" }}
                />
              );
              setColorssd("#F93154");
              setIcnd(
                <i className="fas fa-percent" style={{ color: "#F93154" }} />
              );
            } else if (datos[to] < datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setMenor(2);
              setMenorpii(
                <i
                  className="fas fa-arrow-up me-2"
                  style={{ color: "#00B74A" }}
                />
              );
              setColorssd("#00B74A");
              setIcnd(
                <i className="fas fa-percent" style={{ color: "#00B74A" }} />
              );
            } else if ((datos[to] = datos[te])) {
              setMenor(3);
              setMenorpii(
                <i
                  className="fas fa-equals me-2"
                  style={{ color: "#025558" }}
                />
              );
              setColorssd("#025558");
              setIcnd(
                <i className="fas fa-percent" style={{ color: "#025558" }} />
              );
            }
            setTotalu(totalpcp);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => setActivate(false));
  };

  const seleccionarIngresos = (a) => {
    let endpoint = `${op.conexion}/api/valorute/seleccionarcajaingre?anio=${a}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            let meses = [];
            let montos = [];
            let metageneral = [];

            for (let i = 0; i < response.data.length; i++) {
              meses.push(response.data[i].out_mes);
              montos.push(response.data[i].out_monto);
              metageneral.push("88250.51");
            }
            setMesesIngresoGeneral(meses);
            setIngresos(montos);
            setMetaIngreGeneral(metageneral);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => setActivate(false));
  };

  const seleccionarIngresosxTipo = () => {
    let a = parseInt(fechaSistema.substring(0, 4));
    let ini = "01-01-";
    let fin = "31-12-";

    let endpoint = `${
      op.conexion
    }/api/valorute/seleccionarporfehcaingre?fechaini=${ini + a}&fechafin=${
      fin + a
    }`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            var datos = [];
            var nomb = [];
            let contar = 0;
            let color = [];
            let contarm = [];
            let uno = 0;
            let dos = 0;
            let tres = 0;
            let cuatro = 0;
            let cinco = 0;
            let cuno = 0;
            let cdos = 0;
            let ctres = 0;
            let ccuatro = 0;
            let ccinco = 0;

            for (let i = 0; i < response.data.length; i++) {
              contar = contar + 1;
              var mont = 0.0;
              mont = parseFloat(response.data[i].out_monto);
              contarm.push({
                count: contar,
                monts: mont,
              });

              nomb.push(response.data[i].out_descrip);
            }

            for (let e = 0; e < contarm.length; e++) {
              if (contarm[e].count === 1) {
                uno = contarm[e].monts;
              } else if (contarm[e].count === 2) {
                dos = contarm[e].monts;
              } else if (contarm[e].count === 3) {
                tres = contarm[e].monts;
              } else if (contarm[e].count === 4) {
                cuatro = contarm[e].monts;
              } else if (contarm[e].count === 5) {
                cinco = contarm[e].monts;
              }
            }

            datos.push(
              (cuno = uno),
              (cdos = dos),
              (ctres = tres),
              (ccuatro = cuatro),
              (ccinco = cinco)
            );

            color.push(
              (cuno =
                uno > parseFloat(metv[0].muno) ? "rgb(22, 99, 00)" : "#dc3545"),
              (cdos =
                dos > parseFloat(metv[0].mdos) ? "rgb(22, 99, 00)" : "#dc3545"),
              (ctres =
                tres > parseFloat(metv[0].mtres)
                  ? "rgb(22, 99, 00)"
                  : "#dc3545"),
              (ccuatro =
                cuatro > parseFloat(metv[0].mcuatro)
                  ? "rgb(22, 99, 00)"
                  : "#dc3545"),
              (ccinco =
                cinco > parseFloat(metv[0].mcinco)
                  ? "rgb(22, 99, 00)"
                  : "#dc3545")
            );
            setValorimp(datos);
            setNomimp(nomb);
            setColorG(color);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => setActivate(false));
  };

  const onChange = (event) => {
    if (event.target.name === "mes") {
      const selectedIndex = event.target.options.selectedIndex;
      seleccionarValorPetro(selectedIndex);
      setValor([]);
      setLabel([]);
      setMenor([]);
      setTotal(0.0);
      setActivate(true);
    } else if (event.target.name === "mesut") {
      const selectedIndex = event.target.options.selectedIndex;
      seleccionarValorUT(selectedIndex);
      setValoru([]);
      setLabelu([]);
      setMenor([]);
      setTotalu(0.0);
      setActivate(true);
    }
  };

  useEffect(() => {
    txtMesPetro.current.value = moment(fechaSistema).format("MM");
    txtMesUTE.current.value = moment(fechaSistema).format("MM");
    seleccionarValorPetro(moment(fechaSistema).format("MM"));
    seleccionarValorUT(moment(fechaSistema).format("MM"));
    seleccionarIngresos(moment(fechaSistema).format("YYYY"));
    seleccionarIngresosxTipo();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Chart.js Line Chart",
      },
    },
  };

  const data = {
    labels: mesesIngresoGeneral,
    datasets: [
      {
        label: "Recaudado",
        data: ingresos,
        borderColor: "rgb(22, 99, 00)",
      },
      {
        label: "Meta Presupuestaria",
        data: metaIngreGeneral,
        borderColor: "rgb(2, 99, 132)",
      },
    ],
  };

  const optionss = {
    plugins: {
      title: {
        display: true,
        text: "Chart.js Bar Chart - Stacked",
      },
    },
    responsive: true,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  var metas = ["174001.22", "174001.22", "174001.22", "174001.22", "174001.22"];

  const datas = {
    labels: nomimp,
    datasets: [
      {
        label: "Meta Presupuestaria",
        data: metas,
        backgroundColor: "rgba(53, 162, 235)",
        stack: "Stack 1",
      },
      {
        label: "Recaudado",
        data: valorimp,
        backgroundColor: colorG,
        stack: "Stack 2",
      },
    ],
  };

  const optionsn = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Chart.js Line Chart",
      },
    },
  };

  const datan = {
    labels: label,
    datasets: [
      {
        label: "Variación de la Unidad Contable",
        data: valor,
        borderColor: "#dc3545",
      },
    ],
  };

  const optionsnu = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Chart.js Line Chart",
      },
    },
  };

  const datanu = {
    labels: labelu,
    datasets: [
      {
        label: "Variación de la Unidad Tributaria Estadal",
        data: valoru,
        borderColor: "rgb(2, 99, 132)",
      },
    ],
  };

  return (
    <div>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <div className="container-fluid px-3 py-2">
        <div className="row">
          <div className="col-md-6 h-25">
            <div className="row py-0 my-0 m-0">
              <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>
                Ingreso General
              </h5>
              <hr className="w-50 my-0" />
            </div>
            <Line options={options} data={data} />
          </div>
          <div className="col-md-6 h-25">
            <div className="row py-0 my-0 m-0">
              <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>
                Ingreso por Rubro
              </h5>
              <hr className="w-50 my-0" />
            </div>
            <Bar options={optionss} data={datas} />
          </div>
          <div className="card col-md-6 h-25">
            <div className="card-body row">
              <div className="col-md-2">
                <div className="row justify-content-center">
                  <div
                    className="card text-black"
                    style={{ boxShadow: "0px 0px 10px 1px #aaaaaa" }}
                  >
                    <div
                      className="card-img-top fw-bold"
                      style={{ fontSize: 12 }}
                    >
                      UCT
                    </div>
                    <div className="">
                      <div className="text-center">
                        <div className="d-flex justify-content-start">
                          <span>
                            {menorp === 7
                              ? menorpi
                              : menorp === 5
                              ? menorpi
                              : menorpi}
                          </span>
                          <span
                            style={{
                              color:
                                menorp === 7
                                  ? colorss
                                  : menorp === 5
                                  ? colorss
                                  : colorss,
                            }}
                            className="fw-bold"
                          >
                            {total}
                          </span>
                          <span>
                            {menorp === 7 ? icn : menorp === 5 ? icn : icn}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <select
                    className="form-select form-select-sm"
                    ref={txtMesPetro}
                    name="mes"
                    defaultValue=""
                    aria-label=".form-select-sm example"
                    onChange={onChange}
                  >
                    <option value="">Mes</option>
                    <option value={1}>Enero</option>
                    <option value={2}>Febrero</option>
                    <option value={3}>Marzo</option>
                    <option value={4}>Abril</option>
                    <option value={5}>Mayo</option>
                    <option value={6}>Junio</option>
                    <option value={7}>Julio</option>
                    <option value={8}>Agosto</option>
                    <option value={9}>Septiembre</option>
                    <option value={10}>Octubre</option>
                    <option value={11}>Noviembre</option>
                    <option value={12}>Diciembre</option>
                  </select>
                </div>
              </div>
              <div className="col-md-10">
                <Line options={optionsn} data={datan} />
              </div>
            </div>
          </div>
          <div className="card col-md-6 h-25">
            <div className="card-body row">
              <div className="col-md-10">
                <Line options={optionsnu} data={datanu} />
              </div>
              <div className="col-md-2">
                <div className="row justify-content-center">
                  <div
                    className="card text-black"
                    style={{ boxShadow: "0px 0px 10px 1px #aaaaaa" }}
                  >
                    <div
                      className="card-img-top fw-bold"
                      style={{ fontSize: 12 }}
                    >
                      UTE
                    </div>
                    <div className="">
                      <div className="text-center">
                        <div className="d-flex justify-content-start">
                          <span>
                            {menor === 6
                              ? menorpii
                              : menor === 3
                              ? menorpii
                              : menorpii}
                          </span>
                          <span
                            style={{
                              color:
                                menor === 6
                                  ? colorssd
                                  : menor === 3
                                  ? colorssd
                                  : colorssd,
                            }}
                            className="fw-bold"
                          >
                            {totalu}
                          </span>
                          <span>
                            {menor === 6 ? icnd : menor === 3 ? icnd : icnd}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <select
                    className="form-select form-select-sm"
                    name="mesut"
                    defaultValue=""
                    ref={txtMesUTE}
                    aria-label=".form-select-sm example"
                    onChange={onChange}
                  >
                    <option value="">Mes</option>
                    <option value={1}>Enero</option>
                    <option value={2}>Febrero</option>
                    <option value={3}>Marzo</option>
                    <option value={4}>Abril</option>
                    <option value={5}>Mayo</option>
                    <option value={6}>Junio</option>
                    <option value={7}>Julio</option>
                    <option value={8}>Agosto</option>
                    <option value={9}>Septiembre</option>
                    <option value={10}>Octubre</option>
                    <option value={11}>Noviembre</option>
                    <option value={12}>Diciembre</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Inicio;



// WEBPACK FOOTER //
// ./src/pages/Inicio.js